import TextSingleLine from 'Survey/components/question-types/TextSingleLine'
import MultipleChoice from 'Survey/components/question-types/MultipleChoice'
import MultipleSelect from 'Survey/components/question-types/MultipleSelect'
import Date from 'Survey/components/question-types/Date'
import File from 'Survey/components/question-types/File'
import Checkbox from 'Survey/components/question-types/Checkbox'
import Score from 'Survey/components/question-types/Score'
import PhoneNumber from 'Survey/components/question-types/PhoneNumber'
import OptInRadio from 'Survey/components/question-types/OptInRadio'

import './DashboardTable.scoped.scss'
import { useAct } from 'DashboardUser/store'

const questionTypeComponents = {
  'text': TextSingleLine,
  'multiple_choice': MultipleChoice, // radios
  'multiple_select': MultipleSelect, // checkboxes
  'checkbox': Checkbox,
  'score': Score,
  'ranking': Score,
  'name': TextSingleLine,
  'email': TextSingleLine,
  'postcode': TextSingleLine,
  'phone_number': PhoneNumber,
  'instruction': () => <div />,
  'opt_in_radio': OptInRadio,
  'date': Date,
  'file': File,
  'unknown': () => <div>Unknown</div>,
}

export default function DashboardField ({ field, dashboardTarget, className = '' }) {
  if (field.source === 'answerable_question') {
    return <AnswerCell field={field} dashboardTarget={dashboardTarget} className={className} />
  }

  const value = dashboardTarget.fields[field.id]
  if (field.source === 'column') {
    return <span className={className}>{ value }</span>;
  } else {
    return <span className={className}>{ value }</span>;
  }
}

function AnswerCell({ field, dashboardTarget, className = ''}) {
  const act = useAct()

  const questionId = field.questionId
  const question = useSel(s => s.dashboard.survey.questions.find(q => q.id === questionId))
  const answers = question.answers
  const value = dashboardTarget.fields[field.id]
  const QuestionType = questionTypeComponents[question.questionType] || questionTypeComponents['unknown']

  function onChange(answer) {
    act.app.answerQuestion({ dashboardTargetId: dashboardTarget.id, questionId, answer })
  }

  return (
    <QuestionType
      name={field.name}
      type={question.questionType}
      label={''}
      answers={answers}
      response={value}
      setResponse={onChange}
      settings={{}}
      placeholder={null}
      className={className}
    />
  )
}
